import { supportForm } from "../common/constants";

const PendingNonBiometricSession = ()=>{
    return (
        <div className='container onload-bg-img'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='pending-response'>
            <p>Verification Pending</p>
    <div className='description'>
    Thank you for submitting your request.
    <br/><br/>
    <p className="description-body">
    To complete the identity verification process, 
    please follow the <em><b>Steps</b></em> outlined below:</p>
    <ul>
        <li>Click the button below to request a follow-up from ID Verification Support</li>
        <li>Join with a device with a camera to capture a picture during the call</li>
        <li>Have your photo ID (previously scanned through CLEAR) ready to review</li>
    </ul>
        <a
            href={supportForm}
            target="_blank"
            rel="noopener noreferrer"
            className="join-now-btn"
        >
            Fill Form
        </a>
    </div>
    
        </div>
            </div>
            </div>
    </div>

    )
    
};

export default PendingNonBiometricSession;